import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  registrationError: null,
  message: null,
  loading: false,
  user: null,
  success: false,
  error: false
};

const registerSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    registerUserSuccessful(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.success = true;
      state.registrationError = null;
    },
    registerUserFailed(state, action) {
      state.user = null;
      state.loading = false;
      state.registrationError = action.payload;
      state.error = true;
    },
    resetRegisterFlagChange(state) {
      state.success = false;
      state.error = false;
    },
    apiErrorChange(state, action){
      state.error = action.payload;
      state.loading = false;
      state.isUserLogout = false;
    },
    // Weryfikacja emaila
    verifyEmailRequest(state) {
      state.loading = true;
      state.error = null;
    },
    verifyEmailSuccess(state, action) {
      state.loading = false;
      state.verificationSuccess = true;
      state.user = action.payload;
      state.error = null;
    },
    verifyEmailError(state, action) {
      state.loading = false;
      state.verificationSuccess = false;
      state.error = action.payload;
    },

    // Reset
    registerReset(state) {
      state.success = false;
      state.verificationSuccess = false;
      state.loading = false;
      state.error = null;
      state.violations = null;
      state.user = null;
    },
  }
});

export const {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
  apiErrorChange,
  verifyEmailRequest,
  verifyEmailSuccess,
  verifyEmailError,
  registerReset,
} = registerSlice.actions;

export default registerSlice.reducer;
